import { getTimerTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getSpanShortcodeWrapper } from "../../shortodeAddition";

const timerConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Timer",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "quantity",
          label: "Minute count",
        },
      ],
    },
    initialData: {
      quantity: "2",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const pattern = /^\d+$/;
      if (!pattern.test(data.quantity)) {
        tinymce.activeEditor.windowManager.alert("Invalid input! Only number available.");
      } else {
        const templateToAdd = getTimerTemplate(data.quantity + ":00");

        const shortcodeWrapper = getSpanShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd, "timer", false);
        addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api, false);
        api.close();
      }
    },
  });
};

export { timerConfig };
